import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f9fafb;
}`],
})
export class PageDashboardComponent implements OnInit {
    public Math = Math;
    public metrics: any[] = [];
    public layers: any[] = [];
    public flow: any[] = [];
    public entrypoints: any[] = [];
    public qaStages: any[] = [];
    public actionItems: any[] = [];
    public risks: any[] = [];
    public collections: any[] = [];
    public recentDocuments: any[] = [];
    public recentJobs: any[] = [];
    public gateFailures: any[] = [];
    public latest: any = {};
    public counts: any = {};
    public milvus: any = {};
    public harnessMeta: any = {};
    public loading: boolean = true;
    public refreshing: boolean = false;
    public error: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load(false);
    }

    public async load(_refresh: boolean = false) {
        this.loading = !this.hasOverviewData;
        this.refreshing = true;
        this.error = '';
        await this.service.render();

        const { code, data } = await wiz.call("overview");
        if (code === 200) {
            this.applyOverview(data || {});
        } else {
            this.error = data?.message || '대시보드 데이터를 불러오지 못했습니다.';
        }

        this.loading = false;
        this.refreshing = false;
        await this.service.render();
    }

    public get hasOverviewData() {
        return Object.keys(this.counts || {}).length > 0 || (this.flow || []).length > 0 || (this.actionItems || []).length > 0;
    }

    private applyOverview(data: any) {
        this.metrics = data.metrics || [];
        this.layers = data.layers || [];
        this.flow = data.flow || [];
        this.entrypoints = data.entrypoints || [];
        this.qaStages = data.qaStages || [];
        this.actionItems = data.actionItems || [];
        this.risks = data.risks || [];
        this.collections = data.collections || [];
        this.recentDocuments = data.recentDocuments || [];
        this.recentJobs = data.recentJobs || [];
        this.gateFailures = data.gateFailures || [];
        this.latest = data.latest || {};
        this.counts = data.counts || {};
        this.milvus = data.milvus || {};
        this.harnessMeta = data.harnessMeta || {};
    }

    private count(key: string) {
        return this.rawNumber(this.counts?.[key]);
    }

    public get attentionTotal() {
        return this.count('file_gap')
            + this.count('file_failed')
            + this.count('ocr_failed')
            + this.count('embedding_failed')
            + this.count('vectors_failed')
            + this.count('gate_attention')
            + this.count('review_returned')
            + this.count('eval_failed')
            + this.count('eval_failed_cases')
            + this.count('run_failed')
            + this.count('artifact_failed');
    }

    public get waitingTotal() {
        return this.count('run_active')
            + this.count('artifact_pending')
            + this.count('file_pending')
            + this.count('ocr_pending')
            + this.count('embedding_pending')
            + this.count('vectors_pending')
            + this.count('review_queue')
            + this.count('eval_active');
    }

    public get failureTotal() {
        return this.count('file_failed')
            + this.count('ocr_failed')
            + this.count('embedding_failed')
            + this.count('vectors_failed')
            + this.count('eval_failed')
            + this.count('eval_failed_cases')
            + this.count('run_failed')
            + this.count('artifact_failed');
    }

    public get outageTotal() {
        return this.failureTotal
            + this.count('gate_failed')
            + this.count('gate_blocked');
    }

    public get completedTotal() {
        return this.count('ocr_completed')
            + this.count('vectors_indexed')
            + this.count('review_completed')
            + this.count('eval_completed');
    }

    public get operationState() {
        if (this.outageTotal > 0) return 'outage';
        if (this.attentionTotal > 0 || this.waitingTotal > 0) return 'warning';
        return 'normal';
    }

    public get operationStateLabel() {
        switch (this.operationState) {
            case 'outage': return '장애';
            case 'warning': return '주의';
            default: return '정상';
        }
    }

    public get operationStateCaption() {
        switch (this.operationState) {
            case 'outage': return '실패 항목 있음';
            case 'warning': return '확인 대기 있음';
            default: return '긴급 항목 없음';
        }
    }

    public get operationMessage() {
        if (this.operationState === 'outage') {
            return '실패한 처리 단계가 있습니다. 아래의 먼저 조치할 항목부터 확인하세요.';
        }
        if (this.operationState === 'warning') {
            return '진행 중이거나 확인 대기 중인 항목이 있습니다. 처리 중 항목의 완료 여부를 확인하세요.';
        }
        return '현재 운영 흐름에 긴급 조치가 없습니다. 최근 실행 이력만 정기적으로 확인하세요.';
    }

    public get operationNextTitle() {
        const action = this.primaryActionItem;
        if (action) return this.actionPrompt(action);
        const processing = this.processingItems[0];
        if (processing) return `${processing.label} 상태 확인`;
        return '최근 실행 이력 확인';
    }

    public get operationNextMessage() {
        const action = this.primaryActionItem;
        if (action) return `${action.label} ${action.value}건이 남아 있습니다. 관련 화면에서 원인을 확인하세요.`;
        const processing = this.processingItems[0];
        if (processing) return `${processing.label} ${processing.value}건이 진행 중입니다. 완료 또는 실패 전환 여부를 확인하세요.`;
        return '조치 필요 항목과 처리 중 항목이 없으므로 최근 실행 결과만 점검하면 됩니다.';
    }

    public get operationRoute() {
        return this.primaryActionItem?.href || this.processingItems[0]?.href || '/harness';
    }

    public get operationRouteLabel() {
        if (this.primaryActionItem) return '조치 화면으로 이동';
        if (this.processingItems.length > 0) return '처리 현황 보기';
        return '운영 점검 보기';
    }

    public get operationPanelClass() {
        switch (this.operationState) {
            case 'outage': return 'border-rose-200 bg-rose-50';
            case 'warning': return 'border-amber-200 bg-amber-50';
            default: return 'border-emerald-200 bg-emerald-50';
        }
    }

    public get operationStateTextClass() {
        switch (this.operationState) {
            case 'outage': return 'text-rose-700';
            case 'warning': return 'text-amber-700';
            default: return 'text-emerald-700';
        }
    }

    public get operationBadgeClass() {
        switch (this.operationState) {
            case 'outage': return 'border-rose-200 bg-white text-rose-700';
            case 'warning': return 'border-amber-200 bg-white text-amber-700';
            default: return 'border-emerald-200 bg-white text-emerald-700';
        }
    }

    public get operationButtonClass() {
        switch (this.operationState) {
            case 'outage': return 'bg-rose-600 text-white hover:bg-rose-500';
            case 'warning': return 'bg-amber-600 text-white hover:bg-amber-500';
            default: return 'bg-emerald-600 text-white hover:bg-emerald-500';
        }
    }

    public get priorityActionItems() {
        return (this.actionItems || [])
            .filter((item: any) => this.itemRaw(item) > 0)
            .map((item: any) => ({
                ...item,
                label: this.displayCopy(item.label),
                sub: this.displayCopy(item.sub),
            }))
            .slice(0, 6);
    }

    public get primaryActionItem() {
        return this.priorityActionItems[0] || null;
    }

    public get processingItems() {
        const items = [
            {
                label: '운영 작업',
                value: this.count('run_active') + this.count('artifact_pending'),
                prompt: `실행 중 작업 ${this.number(this.count('run_active'))}건 / 자료 대기 ${this.number(this.count('artifact_pending'))}건`,
                tone: 'amber',
                href: '/harness',
            },
            {
                label: '자료 처리',
                value: this.count('file_pending') + this.count('ocr_pending') + this.count('embedding_pending') + this.count('vectors_pending'),
                prompt: `원본 자료 대기 ${this.number(this.count('file_pending'))}건 / 텍스트 추출·근거 준비 대기 ${this.number(this.count('ocr_pending') + this.count('embedding_pending') + this.count('vectors_pending'))}건`,
                tone: 'blue',
                href: '/literature',
            },
            {
                label: 'QA 후보 생성',
                value: this.count('dataset_draft'),
                prompt: `후보 생성 대기 ${this.number(this.count('dataset_draft'))}건`,
                tone: 'amber',
                href: '/qa',
            },
            {
                label: '검수 진행',
                value: this.count('review_queue'),
                prompt: `검수 대기 ${this.number(this.count('review_pending'))}건 / 배정 ${this.number(this.count('review_assigned'))}건`,
                tone: 'cyan',
                href: '/review',
            },
            {
                label: '평가 실행',
                value: this.count('eval_active'),
                prompt: `평가 실행 중 ${this.number(this.count('eval_active'))}건`,
                tone: 'green',
                href: '/eval',
            },
        ];

        return items
            .filter((item: any) => item.value > 0)
            .map((item: any) => ({ ...item, value: this.number(item.value) }))
            .slice(0, 5);
    }

    private areaStatus(attention: number, pending: number, ready: any = true) {
        if (attention > 0) return 'attention';
        if (pending > 0) return 'pending';
        return ready ? 'ready' : 'empty';
    }

    public get workCards() {
        const fileAttention = this.count('file_gap') + this.count('file_failed') + this.count('ocr_failed') + this.count('embedding_failed') + this.count('vectors_failed');
        const filePending = this.count('file_pending') + this.count('ocr_pending') + this.count('embedding_pending') + this.count('vectors_pending');
        const qaAttention = this.count('h3_gate_attention');
        const qaPending = this.count('dataset_draft');
        const reviewAttention = this.count('review_returned') + this.count('eval_failed') + this.count('eval_failed_cases');
        const reviewPending = this.count('review_queue') + this.count('eval_active');

        return [
            {
                label: '자료 준비',
                value: `${this.number(this.count('documents'))}건`,
                caption: 'QA 근거로 쓸 자료',
                href: '/literature',
                action: '자료 보기',
                status: this.areaStatus(fileAttention, filePending, this.count('documents')),
                stats: [
                    { label: '원본', value: `${this.number(this.count('ledger_files') || this.count('files'))}개` },
                    { label: '텍스트', value: `${this.number(this.count('pages'))}쪽` },
                ],
            },
            {
                label: 'QA 작성',
                value: `${this.number(this.count('h3_items') || this.count('dataset_items'))}건`,
                caption: '생성된 QA 후보',
                href: '/qa',
                action: 'QA 보기',
                status: this.areaStatus(qaAttention, qaPending, this.count('h3_items') || this.count('dataset_items')),
                stats: [
                    { label: '생성 대기', value: `${this.number(this.count('dataset_draft'))}건` },
                    { label: '승인', value: `${this.number(this.count('h3_approved') || this.count('dataset_approved'))}건` },
                ],
            },
            {
                label: '검수/평가',
                value: `${this.number(reviewPending)}건`,
                caption: '검수 또는 평가 진행',
                href: reviewPending ? '/review' : '/eval',
                action: '결과 보기',
                status: this.areaStatus(reviewAttention, reviewPending, this.count('reviews') || this.count('evals')),
                stats: [
                    { label: '검수 대기', value: `${this.number(this.count('review_queue'))}건` },
                    { label: '평가셋', value: `${this.number(this.count('eval_items'))}건` },
                ],
            },
        ];
    }

    public get focusTitle() {
        if (this.priorityActionItems.length > 0) return '오늘 먼저 볼 항목';
        if (this.processingItems.length > 0) return '진행 중인 작업';
        return '최근 실행 결과';
    }

    public get focusBadgeLabel() {
        if (this.priorityActionItems.length > 0) return `${this.number(this.attentionTotal)}건`;
        if (this.processingItems.length > 0) return `${this.number(this.waitingTotal)}건`;
        return `${this.number(this.recentSignals.length)}건`;
    }

    public get focusItems() {
        const actions = this.priorityActionItems.map((item: any) => ({
            title: this.actionPrompt(item),
            meta: item.label,
            value: `${item.value}건`,
            tone: item.tone,
            href: item.href,
            status: 'attention',
        }));
        if (actions.length > 0) return actions.slice(0, 4);

        const processing = this.processingItems.map((item: any) => ({
            title: item.label,
            meta: item.prompt,
            value: `${item.value}건`,
            tone: item.tone,
            href: item.href,
            status: 'pending',
        }));
        if (processing.length > 0) return processing.slice(0, 4);

        return this.recentSignals.map((item: any) => ({
            title: item.label,
            meta: item.sub,
            value: this.statusLabel(item.status),
            tone: item.tone,
            href: item.href,
            status: item.status,
        })).slice(0, 4);
    }

    public get overallStatus() {
        if (this.attentionTotal > 0) return 'attention';
        if (this.waitingTotal > 0) return 'pending';
        return 'ready';
    }

    public get overallHeadline() {
        if (this.attentionTotal > 0) return `조치 필요 ${this.number(this.attentionTotal)}건`;
        if (this.waitingTotal > 0) return `처리 중 ${this.number(this.waitingTotal)}건`;
        return '정상 운영';
    }

    public get overviewCards() {
        const fileAttention = this.count('file_gap') + this.count('file_failed') + this.count('ocr_failed') + this.count('embedding_failed');
        const filePending = this.count('file_pending') + this.count('ocr_pending') + this.count('embedding_pending');
        const evalAttention = this.count('eval_failed') + this.count('eval_failed_cases');

        return [
            {
                label: '자료 컬렉션',
                value: this.number(this.count('collections')),
                sub: `준비 자료 ${this.number(this.count('documents'))}건`,
                href: '/literature',
                tone: 'blue',
                status: this.count('collections') ? 'ready' : 'empty',
            },
            {
                label: '자료 준비',
                value: this.number(this.count('documents')),
                sub: `원본 자료 ${this.number(this.count('ledger_files') || this.count('files'))}개 / 텍스트 추출 ${this.number(this.count('pages'))}쪽`,
                href: '/literature',
                tone: 'green',
                status: fileAttention ? 'attention' : (filePending ? 'pending' : 'ready'),
            },
            {
                label: '처리 중',
                value: this.number(this.waitingTotal),
                sub: `작업 ${this.number(this.count('run_active'))} / 텍스트 추출 ${this.number(this.count('ocr_pending'))} / 근거 준비 ${this.number(this.count('embedding_pending') + this.count('vectors_pending'))}`,
                href: '/harness',
                tone: 'amber',
                status: this.waitingTotal ? 'pending' : 'ready',
            },
            {
                label: '조치 필요',
                value: this.number(this.attentionTotal),
                sub: `실패 ${this.number(this.failureTotal)} / 점검 ${this.number(this.count('gate_attention'))}`,
                href: '/harness',
                tone: this.attentionTotal ? 'red' : 'green',
                status: this.attentionTotal ? 'attention' : 'ready',
            },
            {
                label: '검수 대기',
                value: this.number(this.count('review_queue')),
                sub: `완료 ${this.number(this.count('review_completed'))} / 반려 ${this.number(this.count('review_returned'))}`,
                href: '/review',
                tone: 'cyan',
                status: this.count('review_returned') ? 'attention' : (this.count('review_queue') ? 'pending' : 'ready'),
            },
            {
                label: '평가/골든셋',
                value: `${this.number(this.count('eval_items'))} / ${this.number(this.count('golden_items'))}`,
                sub: `평가 실행 ${this.number(this.count('evals'))} / 실패 ${this.number(evalAttention)}`,
                href: '/eval',
                tone: evalAttention ? 'red' : 'indigo',
                status: evalAttention ? 'attention' : (this.count('eval_active') ? 'pending' : 'ready'),
            },
        ];
    }

    public get supportingMetrics() {
        const fileAttention = this.count('file_gap') + this.count('file_failed') + this.count('ocr_failed') + this.count('embedding_failed') + this.count('vectors_failed');
        const filePending = this.count('file_pending') + this.count('ocr_pending') + this.count('embedding_pending') + this.count('vectors_pending');
        const reviewAttention = this.count('review_returned');
        const evalAttention = this.count('eval_failed') + this.count('eval_failed_cases');
        const operationAttention = this.count('run_failed') + this.count('artifact_failed') + this.count('gate_failed') + this.count('gate_blocked');
        const operationPending = this.count('run_active') + this.count('artifact_pending') + this.count('gate_pending');

        return [
            {
                label: '자료',
                value: `${this.number(this.count('documents'))}건`,
                prompt: `원본 자료 ${this.number(this.count('ledger_files') || this.count('files'))}개 / 텍스트 추출 ${this.number(this.count('pages'))}쪽`,
                href: '/literature',
                status: fileAttention ? 'attention' : (filePending ? 'pending' : 'ready'),
            },
            {
                label: '검수',
                value: `${this.number(this.count('review_queue'))}건 대기`,
                prompt: `완료 ${this.number(this.count('review_completed'))}건 / 반려 ${this.number(this.count('review_returned'))}건`,
                href: '/review',
                status: reviewAttention ? 'attention' : (this.count('review_queue') ? 'pending' : 'ready'),
            },
            {
                label: '평가',
                value: `${this.number(this.count('eval_items'))} / ${this.number(this.count('golden_items'))}`,
                prompt: `평가셋 / 골든셋 · 실패 ${this.number(evalAttention)}건`,
                href: '/eval',
                status: evalAttention ? 'attention' : (this.count('eval_active') ? 'pending' : 'ready'),
            },
            {
                label: '운영',
                value: `${this.number(this.count('runs'))}건`,
                prompt: `작업 ${this.number(this.count('run_active'))}건 / 상태 점검 ${this.latest.gates || '0'}건`,
                href: '/harness',
                status: operationAttention ? 'attention' : (operationPending ? 'pending' : 'ready'),
            },
        ];
    }

    public get quickLinks() {
        return [
            { label: '자료 준비', href: '/literature' },
            { label: 'QA 작성', href: '/qa' },
            { label: '검수 결과', href: '/review' },
            { label: '평가/골든셋', href: '/eval' },
            { label: '운영 점검', href: '/harness' },
            { label: '사용자/권한', href: '/members' },
        ];
    }

    public actionPrompt(item: any) {
        const label = this.displayCopy(item?.label || '');
        if (label.includes('텍스트') || label.includes('문서')) return '텍스트 추출 상태 확인';
        if (label.includes('근거')) return '근거 준비 상태 확인';
        if (label.includes('QA')) return 'QA 생성 상태 점검';
        if (label.includes('검수')) return '검수 대기와 반려 항목 확인';
        if (label.includes('평가')) return '평가 실패 케이스 확인';
        if (label.includes('운영')) return '운영 상태 점검 확인';
        return label || '조치 항목 확인';
    }

    private itemRaw(item: any) {
        return this.rawNumber(item?.raw ?? item?.value);
    }

    public get recentSignals() {
        const gateItems = (this.gateFailures || []).slice(0, 3).map((gate: any) => ({
            kind: '확인 필요',
            label: this.displayCopy(gate.message || '처리 확인 필요'),
            sub: `${this.severityLabel(gate.severity)} · ${gate.created || '-'}`,
            status: gate.status || 'attention',
            tone: gate.status === 'pending' ? 'amber' : 'red',
            href: '/harness',
        }));
        const jobItems = (this.recentJobs || []).slice(0, 5).map((job: any) => {
            const status = job.status || 'pending';
            const needsAttention = status === 'failed' || status === 'blocked' || this.rawNumber(job.error_count) > 0;
            return {
                kind: needsAttention ? '확인 필요' : '작업',
                label: this.jobTypeLabel(job.job_type),
                sub: `${job.started_at || '-'} · 확인 필요 ${this.number(job.error_count)}건`,
                status,
                tone: needsAttention ? 'red' : (status === 'running' || status === 'queued' ? 'amber' : 'gray'),
                href: '/harness',
            };
        });
        return [...gateItems, ...jobItems].slice(0, 5);
    }

    public get movementLinks() {
        return [
            {
                label: '사용자/권한',
                sub: `등록 사용자 ${this.number(this.count('members'))}명`,
                href: '/members',
                status: 'ready',
            },
            {
                label: '운영 점검',
                sub: `실패 ${this.number(this.count('gate_failed') + this.count('gate_blocked'))} / 대기 ${this.number(this.count('gate_pending'))}`,
                href: '/harness',
                status: (this.count('gate_failed') + this.count('gate_blocked')) ? 'attention' : (this.count('gate_pending') ? 'pending' : 'ready'),
            },
            {
                label: '검수 결과',
                sub: `대기 ${this.number(this.count('review_queue'))} / 반려 ${this.number(this.count('review_returned'))}`,
                href: '/review',
                status: this.count('review_returned') ? 'attention' : (this.count('review_queue') ? 'pending' : 'ready'),
            },
            {
                label: '평가/골든셋',
                sub: `평가셋 ${this.number(this.count('eval_items'))} / 골든셋 ${this.number(this.count('golden_items'))}`,
                href: '/eval',
                status: (this.count('eval_failed') + this.count('eval_failed_cases')) ? 'attention' : (this.count('eval_active') ? 'pending' : 'ready'),
            },
        ];
    }

    public number(value: any) {
        const n = Number(value || 0);
        return n.toLocaleString();
    }

    public percent(value: any) {
        const n = Number(value || 0);
        if (n < 0) return 0;
        if (n > 100) return 100;
        return n;
    }

    public rawNumber(value: any) {
        const n = Number(String(value ?? '').replace(/,/g, ''));
        return Number.isFinite(n) ? n : 0;
    }

    public useVectorFallback() {
        return this.rawNumber(this.counts?.vectors_total) > 0 && this.rawNumber(this.milvus?.total) === 0;
    }

    public vectorCoverage() {
        const milvusTotal = this.rawNumber(this.milvus?.total);
        const milvusIndexed = this.rawNumber(this.milvus?.indexed);
        const countTotal = this.rawNumber(this.counts?.vectors_total);
        const countIndexed = this.rawNumber(this.counts?.vectors_indexed);

        if (countTotal > 0 && milvusTotal === 0) {
            return this.percent(Math.round((countIndexed * 1000) / countTotal) / 10);
        }

        if (milvusTotal > 0) {
            const coverage = this.rawNumber(this.milvus?.coverage) || (milvusIndexed * 100 / milvusTotal);
            return this.percent(Math.round(coverage * 10) / 10);
        }

        return 0;
    }

    public vectorMetric(milvusKey: string, countKey: string) {
        if (this.useVectorFallback()) {
            return this.number(this.counts?.[countKey]);
        }

        const value = this.milvus?.[milvusKey];
        if (value !== undefined && value !== null && value !== '') return value;
        return this.number(this.counts?.[countKey]);
    }

    public vectorStatus() {
        if (!this.useVectorFallback() && this.milvus?.status) return this.milvus.status;
        if (this.rawNumber(this.counts?.vectors_failed) > 0) return 'attention';
        if (this.rawNumber(this.counts?.vectors_pending) > 0) return 'pending';
        if (this.rawNumber(this.counts?.vectors_total) > 0) return 'ready';
        return 'empty';
    }

    public statusLabel(status: string) {
        switch (status) {
            case 'ready': return '정상';
            case 'pending': return '대기';
            case 'attention': return '점검 필요';
            case 'empty': return '자료 없음';
            case 'indexed': return '처리 완료';
            case 'completed': return '처리 완료';
            case 'published': return '게시';
            case 'passed': return '처리 완료';
            case 'running': return '실행 중';
            case 'queued': return '대기';
            case 'draft': return '초안';
            case 'failed': return '점검 필요';
            case 'blocked': return '점검 필요';
            default: return status || '-';
        }
    }

    public vectorSourceLabel(value: string) {
        switch (String(value || '')) {
            case 'doc': return '원본 자료';
            case 'vec': return '근거 자료';
            case 'empty': return '정보 없음';
            default: return value || '-';
        }
    }

    public jobTypeLabel(value: string) {
        switch (String(value || '')) {
            case 'literature.artifact': return '자료 준비';
            case 'dataset.artifact': return 'QA 후보 생성';
            case 'review.inspect': return '검수 점검';
            case 'eval.run': return '평가 실행';
            default: return value || '처리 작업';
        }
    }

    public displayCopy(value: any) {
        return String(value ?? '')
            .replace(/literature\.artifact/gi, '자료 준비')
            .replace(/dataset\.artifact/gi, 'QA 후보 생성')
            .replace(/\bH1\b/gi, '운영')
            .replace(/\bH2\b/gi, '자료 준비')
            .replace(/\bH3\b/gi, 'QA 작성')
            .replace(/\bGate\b/gi, '점검')
            .replace(/\bartifact\b/gi, '자료')
            .replace(/문서 인식/g, '텍스트 추출')
            .replace(/자동 점검/g, '상태 점검')
            .replace(/근거\s*자료\s*처리/g, '근거 준비')
            .replace(/근거\s*처리/g, '근거 준비')
            .replace(/결과물/g, '자료')
            .replace(/OCR·VLM 추출/gi, '텍스트 추출')
            .replace(/OCR\/VLM 추출/gi, '텍스트 추출')
            .replace(/OCR 추출/gi, '텍스트 추출')
            .replace(/VLM 추출/gi, '텍스트 추출')
            .replace(/OCR/gi, '텍스트 추출')
            .replace(/VLM/gi, '텍스트 추출')
            .replace(/embedding/gi, '근거 준비')
            .replace(/vector/gi, '근거 자료')
            .replace(/milvus/gi, '근거 자료 저장소')
            .replace(/색인/g, '준비');
    }

    public severityLabel(value: string) {
        switch (String(value || '').toLowerCase()) {
            case 'error': return '오류';
            case 'warning': return '주의';
            case 'info': return '안내';
            default: return value || '-';
        }
    }

    public toneClass(tone: string) {
        switch (tone) {
            case 'green': return 'bg-emerald-50 text-emerald-700 border-emerald-100';
            case 'amber': return 'bg-amber-50 text-amber-700 border-amber-100';
            case 'blue': return 'bg-sky-50 text-sky-700 border-sky-100';
            case 'indigo': return 'bg-indigo-50 text-indigo-700 border-indigo-100';
            case 'cyan': return 'bg-cyan-50 text-cyan-700 border-cyan-100';
            case 'red': return 'bg-rose-50 text-rose-700 border-rose-100';
            case 'gray': return 'bg-gray-50 text-gray-600 border-gray-200';
            default: return 'bg-sky-50 text-sky-700 border-sky-100';
        }
    }

    public softToneClass(tone: string) {
        switch (tone) {
            case 'green': return 'border-emerald-200 bg-emerald-50/50';
            case 'amber': return 'border-amber-200 bg-amber-50/50';
            case 'blue': return 'border-sky-200 bg-sky-50/50';
            case 'indigo': return 'border-indigo-200 bg-indigo-50/50';
            case 'cyan': return 'border-cyan-200 bg-cyan-50/50';
            case 'red': return 'border-rose-200 bg-rose-50/50';
            default: return 'border-sky-200 bg-sky-50/50';
        }
    }

    public progressClass(tone: string) {
        switch (tone) {
            case 'green': return 'bg-emerald-500';
            case 'amber': return 'bg-amber-500';
            case 'blue': return 'bg-sky-500';
            case 'indigo': return 'bg-indigo-500';
            case 'cyan': return 'bg-cyan-500';
            case 'red': return 'bg-rose-500';
            default: return 'bg-sky-500';
        }
    }

    public dotClass(tone: string) {
        switch (tone) {
            case 'green': return 'bg-emerald-500';
            case 'amber': return 'bg-amber-500';
            case 'blue': return 'bg-sky-500';
            case 'indigo': return 'bg-indigo-500';
            case 'cyan': return 'bg-cyan-500';
            case 'red': return 'bg-rose-500';
            case 'gray': return 'bg-gray-400';
            default: return 'bg-sky-500';
        }
    }

    public statusDotClass(status: string) {
        switch (status) {
            case 'ready':
            case 'indexed':
            case 'completed':
            case 'published':
            case 'passed':
            case 'done':
                return 'bg-emerald-500';
            case 'attention':
            case 'failed':
            case 'blocked':
                return 'bg-rose-500';
            case 'pending':
            case 'running':
            case 'queued':
            case 'draft':
            case 'empty':
                return 'bg-amber-500';
            default:
                return 'bg-gray-300';
        }
    }

    public statusBadgeClass(status: string) {
        switch (status) {
            case 'ready':
            case 'indexed':
            case 'completed':
            case 'published':
            case 'passed':
            case 'done':
                return 'bg-emerald-50 text-emerald-700 border-emerald-200';
            case 'attention':
            case 'failed':
            case 'blocked':
                return 'bg-rose-50 text-rose-700 border-rose-200';
            case 'pending':
            case 'running':
            case 'queued':
            case 'draft':
            case 'empty':
                return 'bg-amber-50 text-amber-700 border-amber-200';
            default:
                return 'bg-gray-50 text-gray-600 border-gray-200';
        }
    }

    public statusClass(status: string) {
        switch (status) {
            case 'ready':
            case 'indexed':
            case 'completed':
            case 'published':
            case 'passed':
            case 'done':
                return 'bg-emerald-50 text-emerald-700 border-emerald-200';
            case 'running':
            case 'queued':
            case 'pending':
            case 'draft':
            case 'empty':
                return 'bg-amber-50 text-amber-700 border-amber-200';
            case 'attention':
            case 'failed':
            case 'blocked':
                return 'bg-rose-50 text-rose-700 border-rose-200';
            default:
                return 'bg-gray-50 text-gray-600 border-gray-200';
        }
    }

    public riskClass(tone: string) {
        switch (tone) {
            case 'red': return 'text-rose-700 bg-rose-50';
            case 'amber': return 'text-amber-700 bg-amber-50';
            case 'green': return 'text-emerald-700 bg-emerald-50';
            case 'cyan': return 'text-cyan-700 bg-cyan-50';
            default: return 'text-gray-600 bg-gray-50';
        }
    }
}

export default PageDashboardComponent;